import { type TiledTileData } from './types.js';

/**
 * Placeholder tileset used until real pixel art exists (Phase 0).
 * The client paints these as flat colours at runtime, so no binary asset is needed.
 * Tile ids are 1-based (Tiled `firstgid` = 1).
 */
export const DEV_TILESET_NAME = 'dev-tiles';

export const DEV_TILES = {
  woodFloor: { id: 1, name: 'wood floor', color: '#c8a27a' },
  tileFloor: { id: 2, name: 'tile floor', color: '#dfe6ea' },
  wall: { id: 3, name: 'wall', color: '#3b4252' },
  carpet: { id: 4, name: 'carpet', color: '#7a8fb3' },
  desk: { id: 5, name: 'desk', color: '#8a5a3c' },
  plant: { id: 6, name: 'plant', color: '#4c9a52' },
  counter: { id: 7, name: 'kitchen counter', color: '#9aa5ad' },
  blocker: { id: 8, name: 'collision marker', color: '#ff00ff' },
  screen: { id: 9, name: 'wall screen', color: '#2f4a6d' },
  screenLit: { id: 10, name: 'wall screen (lit frame)', color: '#4f7cac' },
} as const;

export type DevTileKey = keyof typeof DEV_TILES;
export const DEV_TILE_COUNT = Object.keys(DEV_TILES).length;

/**
 * Tiled animations of the dev tileset, in the tileset's own (0-based) ids: the wall screen glows
 * on and off, so the placeholder office has one animated tile to test with (ADR-0028).
 */
export function devTileAnimations(): TiledTileData[] {
  return [
    {
      id: DEV_TILES.screen.id - 1,
      animation: [
        { tileid: DEV_TILES.screen.id - 1, duration: 600 },
        { tileid: DEV_TILES.screenLit.id - 1, duration: 600 },
      ],
    },
  ];
}
